import * as Yup from "yup";
import { States } from "../../../../constants";
import {
  emailRegEx,
  phoneRegEx,
  websiteRegex,
  zipCodeRegEx,
} from "../../../../utils/RegularExpressions";

export const anyApply = [
  {
    id: "neighborhoodBased",
    name: "neighborhoodBased",
    label: "Neighborhood Based",
  },
  {
    id: "chdoDesignation",
    name: "chdoDesignation",
    label: "CHDO Designation",
  },
  {
    id: "faithBased",
    name: "faithBased",
    label: "Faith Based",
  },
  {
    id: "minorityOwnedCertified",
    name: "minorityOwnedCertified",
    label: "Certified as a Minority Owned",
  },
  {
    id: "vetteranOwned",
    name: "vetteranOwned",
    label: "Veteran Owned",
  },
  {
    id: "veteranOwnedCertified",
    name: "veteranOwnedCertified",
    label: "Certified as Veterans Owned Based",
  },
  {
    id: "bipocOwned",
    name: "bipocOwned",
    label: "BIPOC Owned",
  },
  {
    id: "bipocLed",
    name: "bipocLed",
    label: "BIPOC Led",
  },
  {
    id: "nonProfit",
    name: "nonProfit",
    label: "Non-Profit",
  },
];

const validStateOptions: string[] = [];
States.forEach((state) => validStateOptions.push(state.name));
const today = new Date();

export const validationSchema = Yup.object({
  entityName: Yup.string()
    .required("Enitity Name is required")
    .min(2, "Entity Name must be greater than 2 characters"),
  ein: Yup.string()
    .required("EIN is required")
    .min(9, "EIN must be 9 digits")
    .max(9, "EIN must be 9 digits"),
  contactPersonName: Yup.string()
    .required("Contact Person Full Name is required")
    .min(2, "Contact Person Full Name must be greater than 2 characters"),
  contactPersonEmail: Yup.string()
    .required("Contact Person E-mail is required")
    .matches(emailRegEx, "Invalid E-mail Address"),
  streetAddress: Yup.string()
    .required("Street Address is required")
    .min(4, "Street Address must be greater than 4 character"),
  city: Yup.string()
    .required("City is required")
    .min(2, "City must be greater than 2 character"),
  state: Yup.string()
    .required("State is required")
    .oneOf(validStateOptions, "You must select a valid option"),
  zipCode: Yup.string()
    .required("Zip / Postal code is required")
    .matches(zipCodeRegEx, "Zip / Postal Code must be a 5 digit number")
    .max(5, "Zip / Postal Code must be 5 digits")
    .min(5, "Zip / Postal Code must be 5 digits"),
  phone: Yup.string()
    .required("Phone Number is required")
    .typeError("Phone Number must a number")
    .matches(phoneRegEx, "Phone Number is invalid")
    .min(10, "Phone  number must be 10 digits")
    .max(10, "Phone number must be 10 digits"),
  website: Yup.string()
    .matches(websiteRegex, "Invalid website format")
    .nullable()
    .transform((v) => (v === "" ? null : v)),
  formationDate: Yup.date()
    .typeError("Date is invalid")
    .required("Formation date is required")
    .max(today, "Formation Date cannot be in future."),
  fullTimeEmployeeCount: Yup.number()
    .required("Number of Full Time Employees is required")
    .typeError("Number is required")
    .integer(
      "Number of Full Time Employees must be in whole number. It cannot be in decimal."
    )
    .positive("Number of Full Time Employees cannot be negative")
    .min(1, "Minimum of 1 is required."),
});
